import { RegistryType } from './registry-type';
import { Address } from '../address/address';
import { ContactList } from '../../backend-definitions.module';

export class Firm {
    name: string;
    id: number;
    fullName: string;
    registryType: RegistryType;
    address: Address;
    registry: string;
    cnes: string;
    contactList: ContactList;
    useOrder: boolean;
    active: boolean;
}